import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { it as itLocale } from "react-day-picker/locale";
import { enGB as enLocale } from "react-day-picker/locale";

const bcp47Map: Record<string, string> = {
  it: "it-IT",
  en: "en-GB",
};

const dayPickerLocaleMap: Record<string, typeof itLocale> = {
  it: itLocale,
  en: enLocale,
};

export function useFormatDate() {
  const { i18n } = useTranslation();
  const lang = i18n.language?.split("-")[0] || "it";

  const locale = bcp47Map[lang] || "it-IT";
  const dayPickerLocale = dayPickerLocaleMap[lang] || itLocale;

  const formatDate = useMemo(() => {
    return (
      date: Date | string | number,
      options?: Intl.DateTimeFormatOptions,
    ) => {
      const d =
        typeof date === "string" || typeof date === "number"
          ? new Date(date)
          : date;
      return d.toLocaleDateString(locale, options);
    };
  }, [locale]);

  return { locale, dayPickerLocale, formatDate };
}
